/**
 * @description Enum for once settings properties.
 */
export enum TagOnceSettingsProperties {
	/**
	 * @description Optional delay in milliseconds after creation of player and before attaching a resource.
	 * Should be deleted after use
	 * @type {TagOnceSettingsProperties.DELAY_ATTACH_RESOURCE_MS}
	 */
	DELAY_ATTACH_RESOURCE_MS = 'delayAttachResourceMs',

	/**
	 * @description When `true` for a given `tag.API.VIDEO.load()` call, Smart Tag skips the full
	 * avia-js player destroy/create cycle and calls `attachResource()` on the existing player instance
	 * instead. Combined with `TAG.playerOptions.reuseVideoElement: true` (set at init), this preserves
	 * the `<video>` element across channel changes so Chrome's established autoplay permission is never
	 * lost and the user's mute state is retained (PTVWS-2990).
	 *
	 * **Two flags required for the full fix (PLPSCORE-366 + PTVWS-6017):**
	 * 1. `TAG.playerOptions.reuseVideoElement: true` — set once at init; tells avia-js to skip
	 *    `recreateVideo()` on subsequent `attachResource()` calls and reuse the existing `<video>` element.
	 * 2. `reusePlayerInstance: true` — set on each channel-change `load()` call; tells Smart Tag to
	 *    skip `#atomicPlayerReplacement()` and dispatch `ON_CREATE_PLAYER_SUCCESS` on the existing player.
	 *
	 * Without `reuseVideoElement: true`, avia-js recreates the `<video>` element on every
	 * `attachResource()` call, losing Chrome's autoplay permission and causing muted playback.
	 *
	 * Read and deleted after each use — defaults to `false` on the next load unless explicitly set again.
	 * Pass via the third argument to `tag.API.VIDEO.load( params, callbacks, { reusePlayerInstance: true } )`.
	 * @type {TagOnceSettingsProperties.REUSE_PLAYER_INSTANCE}
	 */
	REUSE_PLAYER_INSTANCE = 'reusePlayerInstance'
}